import { getMerchantById } from '@nemuru-eng/js-api-client';
import { useEffect, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';

import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';

export const MerchantPageTitle = () => {
  const {
    state: { loading },
    actions: pageActions,
  } = usePageContext();

  const { merchantId } = useParams();

  if (!merchantId) return null;

  const { data: merchant, loading: merchantLoading } = useCache(getMerchantById, { merchantId });

  const title = merchant?.registrationFields?.businessName || '';

  useSetPageLoadingWhenRequesting('MERCHANT_DETAILS', [merchantLoading]);

  useEffect(() => {
    if (!merchant && merchantLoading === false) {
      pageActions.setNotFound(true);
    }
  }, [merchantLoading]);

  useLayoutEffect(() => {
    pageActions.setCustomTitle(title);
  }, [title, loading]);

  return <> </>;
};
